export const loginApi = 'https://api.sipanja.lampungprov.go.id:9069/login'
export const token = "https://api.sipanja.lampungprov.go.id:9069/token"
export const logoutUser = 'https://api.sipanja.lampungprov.go.id:9069/logout'